module.exports = __webpack_public_path__ + "static/media/sgd-4.c4fd9b6c.png";